import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StaticMessage, UnsavedChangesDialogOptions } from '@shared/enums';
import { ScreenSizeService } from '@shared/services';
import { map, take } from 'rxjs';

@Component({
  selector: 'app-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesDialogComponent {
  unsavedChangesDialogOptions = UnsavedChangesDialogOptions;
  continueButtonLabel$ = this.screenSizeService.isHandset$.pipe(
    take(1),
    map((isHandset) =>
      isHandset
        ? $localize`:@@shared.unsavedChangesDialog.btnDiscard:Discard`
        : $localize`:@@shared.unsavedChangesDialog.btnDiscardChanges:Discard changes`
    )
  );

  staticMessage = StaticMessage;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      saveButtonLabel: string;
    },
    private screenSizeService: ScreenSizeService
  ) {}
}
